import { render, staticRenderFns } from "./AHTosDialog.vue?vue&type=template&id=12863d52&"
import script from "./AHTosDialog.vue?vue&type=script&lang=ts&"
export * from "./AHTosDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports